
export function getPaddedNumber(num: number): string {
  const stringVal = '0' + num;
  return stringVal.substr(stringVal.length - 2);
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/fields/components/timestamp-field/PadNumber.ts